import React from 'react';
import './Samples.css';

// Small display helpers shared by the sample pages and Order Management.

export const SampleStatusChip = ({ status }) => (
  <span className={`sample-status sample-status-${(status || 'pending').toLowerCase()}`}>
    {status || 'Pending'}
  </span>
);

export const sourceLabel = (sample) =>
  sample.source === 'External'
    ? `Brought from outside${sample.externalSource ? `: ${sample.externalSource}` : ''}`
    : 'Collected in lab';
